import { Peak } from './types';

export interface PeakPreset {
  id: string;
  name: string;
  description: string;
  peaks: Peak[];
}

export const PEAK_PRESETS: PeakPreset[] = [
  {
    id: 'commuter',
    name: 'Commuter',
    description: 'Morning and evening peaks for typical work commutes',
    peaks: [
      { peak_time: '08:00', effect: 4, width_left: 3, width_right: 3 },
      { peak_time: '17:30', effect: 4, width_left: 1, width_right: 3 }
    ]
  },
  {
    id: 'school',
    name: 'School',
    description: 'Peaks aligned with school start and end times',
    peaks: [
      { peak_time: '08:00', effect: 4, width_left: 2, width_right: 1 },
      { peak_time: '15:30', effect: 4, width_left: 2, width_right: 1 }
    ]
  },
  {
    id: 'midday',
    name: 'Midday',
    description: 'Single peak during lunch hours',
    peaks: [
      { peak_time: '12:30', effect: 2.0, width_left: 3, width_right: 3 }
    ]
  },
  {
    id: 'custom',
    name: 'Custom',
    description: 'Manually configure your own peaks',
    peaks: []
  }
];

export function getPresetById(id: string): PeakPreset | undefined {
  return PEAK_PRESETS.find(preset => preset.id === id);
}

export function detectCurrentPreset(currentPeaks: Peak[]): string {
  // Check if peaks match any preset exactly
  for (const preset of PEAK_PRESETS) {
    if (preset.id === 'custom') continue;
    
    if (currentPeaks.length === preset.peaks.length) {
      const matches = currentPeaks.every((peak, index) => {
        const presetPeak = preset.peaks[index];
        return (
          peak.peak_time === presetPeak.peak_time &&
          peak.effect === presetPeak.effect &&
          peak.width_left === presetPeak.width_left &&
          peak.width_right === presetPeak.width_right
        );
      });
      
      if (matches) {
        return preset.id;
      }
    }
  }
  
  return 'custom';
} 
